module.exports = __webpack_public_path__ + "59cb8c7d1e863d131f560ff7b23ef307.png";